import {copyToBuffer, RewardsProgressBar, UserInfoModal as UIModal} from "@housebets/housebets-x-package";
import {useGTMEvents} from "app/hooks/useGTMEvents";

import {IUserInfoModalProps} from "./types";
import {useUserInfoModalData} from "./hooks/useUserInfoModalData";
import {useAppSelector} from "hooks/useAppSelector";
import { useIntl } from "react-intl";

export const UserInfoModal: React.FC<IUserInfoModalProps> = ({isOpen, setIsOpen}) => {
    const {
        mutatedUserData,
        vipWidgetData,
        recentlyGames,
        // rewards
    } = useUserInfoModalData();
    const {modal} = useGTMEvents();
    const otherInfoUser = useAppSelector(state => state.user.otherInfoUser)
    const {$t} = useIntl();

    return (
        <UIModal.Modal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            onNavBack={undefined}
            afterOpenModal={() => {
                modal.show("user_info_modal");
            }}
            onAfterClose={() => {
                modal.close("user_info_modal");
            }}>
            <UIModal.Row>
                <UIModal.UserInfoUser
                    text={{
                        labelCopy: $t({id: "copyToClipboard"}),
                    }}
                    data={mutatedUserData}
                    onShare={() => {
                        copyToBuffer(mutatedUserData.id);
                    }}
                />
            </UIModal.Row>
            <UIModal.Row>
                <UIModal.RowItem>
                    <div>
                        <RewardsProgressBar
                            type="v2"
                            // compact={vipWidgetData.amount > 10000}
                            compact
                              text={{
                                nextTitle: $t({ id: 'VipProgress.nextLevel' }),
                                currentTitle: $t({ id: 'VipProgress.currentReward' }),
                            }}
                            reward={{
                                icon: vipWidgetData.levelTitleOriginal,
                                name: vipWidgetData.levelTitle,
                                xp: {
                                    current: vipWidgetData.amount,
                                    max: vipWidgetData.maxLevel,
                                },
                            }}
                            reducedNumber={vipWidgetData.amount > 1000}
                        />
                    </div>
                    <div>
                        <UIModal.Panel
                            bets={otherInfoUser?.totalBets ? +otherInfoUser?.totalBets : 0}
                            wagered={{
                                amount: otherInfoUser?.totalWargered ? +otherInfoUser?.totalWargered.toFixed(2) : 0,
                                currency: "$",
                            }}
                            wins={otherInfoUser?.totalWins ? +otherInfoUser?.totalWins : 0}
                        />
                    </div>
                </UIModal.RowItem>
            </UIModal.Row>
            {/* TODO: need rework this reward list realization */}
            {/* <UIModal.Row>
                <UIModal.UserInfoRewardsList
                    title="VIP Rewards"
                    rewards={rewards}
                />
            </UIModal.Row> */}
            <UIModal.Row>
                <UIModal.UserInfoGameList title={$t({id: 'RecentlyPlayed'})} games={recentlyGames} />
            </UIModal.Row>
        </UIModal.Modal>
    );
};

UserInfoModal.displayName = "UserInfoModal";
